module.exports = __webpack_public_path__ + "img/pen-solid.912bdd59.svg";